import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { postLike } from "services/apiService";
import { getFeed } from "services/apiService";

export const fetchFeed = createAsyncThunk("fetchFeed", async (number) => {
  try {
    const getFeedRes = await getFeed(number);
    // console.log("here1", getFeedRes);
    return getFeedRes;
  } catch (error) {
    console.log("feedReducerError", error);
  }
});

// export const like = createAsyncThunk("like", async (postId) => {
//   try {
//     const likeRes = await postLike(postId);
//     // console.log("here1", getFeedRes);
//     return likeRes;
//   } catch (error) {
//     console.log("feedReducerError", error);
//   }
// });

const initialState = {
  feed: [],
  feedCount: 0,
  feedPageNumber: 1,
  feedLoading: true,
};

const userFeedSlice = createSlice({
  name: "userFeed",
  initialState: initialState,
  reducers: {
    feedReducer(state, action) {
      state.feed = action.payload;
      state.feedCount = action.payload[0]?.countPost;
      state.feedLoading = false;
    },
    feedReducerPlus(state, action) {
      state.feed.push(...action.payload);
      state.feedPageNumber += 1;
    },
    likeUnLikeCommentReducer(state, action) {
      // console.log("actin", action.payload);
      const updatedPost = action.payload;

      // Create a new array by looping through the feed array
      const updatedFeed = state.feed.map((post) => {
        // If the post id matches with the updated post id, return the updated post
        if (post._id === updatedPost._id) {
          return updatedPost;
        }
        // Otherwise, return the original post
        return post;
      });

      // Update the state with the updated feed array
      state.feed = updatedFeed;
    },
    userFeedReducerReset() {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFeed.pending, (state) => {
        state.feedLoading = true;
      })
      .addCase(fetchFeed.fulfilled, (state, action) => {
        state.feed = action.payload;
        state.feedCount = action.payload[0].countPost;
        state.feedLoading = false;
      });
  },
});

export const {
  feedReducer,
  feedReducerPlus,
  likeUnLikeCommentReducer,
  userFeedReducerReset,
} = userFeedSlice.actions;
export default userFeedSlice.reducer;

// const likeReducer = (state, action) => {
//   const updatedPost = action.payload;

//   // Create a new array by looping through the feed array
//   const updatedFeed = state.feed.map((post) => {
//     // If the post id matches with the updated post id, return the updated post
//     if (post._id === updatedPost._id) {
//       return updatedPost;
//     }
//     // Otherwise, return the original post
//     return post;
//   });

//   // Update the state with the updated feed array
//   state.feed = updatedFeed;
// };
